import React from 'react';
import { Box } from '@mui/material';

export const DEFAULT_CATEGORY_ICON_NAME = 'access_time';

export const CATEGORY_ICON_NAMES = [
  'restaurant',
  'support_agent',
  'medical_services',
  'checkroom',
  'water_drop',
  'wc',
  'shower',
  'local_laundry_service',
  'healing',
  'home',
  'ac_unit',
  'groups',
  'access_time',
  'store',
  'volunteer_activism',
  'church',
  'directions_walk',
  'event',
  'info',
  'syringe',
];

const LEGACY_KEY_TO_ICON_NAME: Record<string, string> = {
  food: 'restaurant',
  counseling: 'support_agent',
  medical: 'medical_services',
  clothing: 'checkroom',
  water: 'water_drop',
  toilets: 'wc',
  showers: 'shower',
  laundry: 'local_laundry_service',
  drugs: 'healing',
  shelter: 'home',
  coolPlaces: 'ac_unit',
  loneliness: 'groups',
};

export function resolveCategoryIconName(
  iconName?: string | null,
  fallbackKey?: string
): string {
  const trimmedIconName = iconName?.trim();
  if (trimmedIconName) {
    return trimmedIconName === 'schedule' ? DEFAULT_CATEGORY_ICON_NAME : trimmedIconName;
  }

  if (fallbackKey && LEGACY_KEY_TO_ICON_NAME[fallbackKey]) {
    return LEGACY_KEY_TO_ICON_NAME[fallbackKey];
  }

  return DEFAULT_CATEGORY_ICON_NAME;
}

interface CategoryIconProps {
  iconName: string;
  fontSize?: number | string;
  color?: string;
  selected?: boolean;
}

export function CategoryIcon({
  iconName,
  fontSize = 24,
  color,
  selected,
}: CategoryIconProps) {
  return (
    <Box
      component="span"
      className="material-symbols-outlined"
      sx={{
        fontSize,
        color: color ?? (selected ? 'primary.main' : 'text.primary'),
        verticalAlign: 'middle',
        lineHeight: 1,
      }}
      aria-hidden
    >
      {iconName}
    </Box>
  );
}

export function getCategoryIcon(
  iconName?: string | null,
  fallbackKey?: string
): React.ReactElement {
  return (
    <CategoryIcon iconName={resolveCategoryIconName(iconName, fallbackKey)} />
  );
}
